import clsx from 'clsx';

import {TREND_THEMES} from '../../../constants/trend-themes';

import styles from '../components/play-off-stages-grid.module.css';

export const getPlayOffStagesGridClassNames = theme => {
  switch (theme) {
    case TREND_THEMES.IHHF:
      return {
        1: clsx(styles.blockMatchPrimary, styles.blockMatchPrimaryIhhf),
        2: clsx(styles.blockMatchPrimary, styles.blockMatchPrimaryIhhf),
        4: clsx(styles.blockMatchSecondary, styles.blockMatchSecondaryWithMargin)
      };
    case TREND_THEMES.FIFA:
      return {
        1: clsx(styles.blockMatchPrimary, styles.blockMatchPrimaryFifa),
        2: clsx(styles.blockMatchPrimary, styles.blockMatchPrimaryFifa),
        4: clsx(styles.blockMatchSecondary, styles.blockMatchSecondaryWithLine, styles.blockMatchSecondaryWithLineFifa),
        8: clsx(styles.blockMatchSecondary, styles.blockMatchSecondaryWithOrdering)
      };
    default:
      return {
        1: clsx(styles.blockMatchPrimary, styles.blockMatchPrimaryEuro),
        2: clsx(styles.blockMatchPrimary, styles.blockMatchPrimaryEuro),
        4: clsx(styles.blockMatchSecondary, styles.blockMatchSecondaryWithLine, styles.blockMatchSecondaryWithLineEuro),
        8: clsx(styles.blockMatchSecondary, styles.blockMatchSecondaryWithOrdering)
      };
  }
};
